import Button, { ButtonProps } from "@mui/material/Button";
import classNames from "classnames";
import React, { forwardRef } from "react";

import "./Button.scss";

export interface ICustomButtonProps extends ButtonProps {
	"data-testid"?: string;
}

const CustomButton = forwardRef<HTMLButtonElement, ICustomButtonProps>((props, ref) => {
	return (
		<Button
			{...props}
			ref={ref}
			color={props.color ?? "primary"}
			variant={props.variant ?? "contained"}
			data-testid={props["data-testid"]}
			className={classNames(props.className, "CustomButton")}
			sx={{ textTransform: "none" }}
		/>
	);
});

export default CustomButton;
